import React from 'react'

import './index.scss'

interface IExtraSmallParagraphRequired {
	children: React.ReactNode
}

interface IExtraSmallParagraphOptional {
	className?: string
}

interface IExtraSmallParagraphProps
	extends IExtraSmallParagraphRequired,
		IExtraSmallParagraphOptional {}

const ExtraSmallParagraph: React.FC<IExtraSmallParagraphProps> = ({
	children,
	className = '',
}) => <p className={`extra-small-paragraph ${className}`}>{children}</p>

export default ExtraSmallParagraph
